<nz-skeleton [nzActive]="true" [nzLoading]="false">
    <nz-layout>
        <div nz-row nzType="flex" nzJustify="center" nzAlign="top" *ngIf="showList">
            <nz-content>
                <div *ngIf="value.notes1" nz-row class="box-color">
                    <div>
                        <ul class="list-class">
                            <li><span>{{value.notes1}}</span></li>
                        </ul>
                    </div>
                </div>
                <div *ngIf="value.notes2" nz-row class="box-color">
                    <div>
                        <ul class="list-class">
                            <li><span>{{value.notes2}}</span></li>
                        </ul>
                    </div>
                </div>
                <div *ngIf="value.notes3" class="box-color">
                    <div>
                        <ul class="list-class">
                            <li><span>{{value.notes3}}</span></li>
                        </ul>
                    </div>
                </div>
                <div *ngIf="value.notes4" class="box-color">
                    <div>
                        <ul class="list-class">
                            <li><span>{{value.notes4}}</span></li>
                        </ul>
                    </div>
                </div>
            </nz-content>
        </div>
        <div nz-row nzType="flex" nzJustify="center" nzAlign="top" *ngIf="!showList">
            <nz-content>
                <div nz-row nzJustify="center">
                    {{"app.common.tariff.viewer.no.notes"|translate}}
                </div>
            </nz-content>
        </div>
    </nz-layout>
</nz-skeleton>